import classNames from 'classnames/bind'
import React from 'react'
import ImageComponent from '@/components/common/Image'
import Link from 'next/link'

import styles from './style.module.scss'
import { safeUrl } from '@/methods/url/safeUrl'

const cx = classNames.bind(styles)

export interface IFeaturedCategory {
  imgUrl: string
  collection: string
  title: string
  highlight: string
  link: string
}

const FeaturedCategoryCard = ({ imgUrl, title, highlight, link }: IFeaturedCategory) => {
  return (
    <Link href={safeUrl(link)} className={cx('featured-category-card')} target='_blank'>
      <div className={cx('featured-category-card__image')}>
        <ImageComponent src={imgUrl} fill alt={title} style={{ objectFit: 'cover' }} sizes='(max-width: 709px) 84px, 56px' />
      </div>
      <div className={cx('featured-category-card__content')}>
        <div className={cx('featured-category-card__title')}>{title}</div>
        <div className={cx('featured-category-card__highlight')}>{highlight}</div>
      </div>
    </Link>
  )
}

export default FeaturedCategoryCard
